<template>
    <div class="policy-upload-form">
        <div class="row">
            <div class="form-group col-12 col-md-8">
                <label for="name">
                    Title <span class="text-danger" aria-hidden="true">*</span><span class="sr-only"> (required)</span>
                </label>
                <input class="form-control" type="text" name="name" id="name" v-model="inputs.name" required />
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12 col-md-6">
                <label for="effective_date">BAA Adopted Date</label>
                <datepicker id="effective_date" :format="customFormatter" name="effective_date" v-model="inputs.effective_date"></datepicker>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-12 col-md-6">
                <label for="renewal_frequency">
                    Review Frequency <span class="text-danger" aria-hidden="true">*</span><span class="sr-only"> (required)</span>
                </label>
                <select class="form-control w-100" name="renewal_frequency" id="renewal_frequency" v-model="inputs.renewal_frequency" required>
                    <option value="" hidden disabled selected>Select Review Frequency</option>
                    <option v-for="(renewFrequencyLabel, renewFrequency) in renewFrequencies" :value="renewFrequency">{{ renewFrequencyLabel }}</option>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-12 col-md-6">
                <input type="checkbox" value="1" v-model="alreadySigned" name="already_signed" id="already_signed" class="form-control"
                       aria-controls="baa-upload-intermediate-fields">
                <label for="already_signed">Already Signed?</label>
                <div class="note">If there are already signatures on this BAA check this box to bypass the normal signature process</div>
            </div>
        </div>

        <!--
            An externally executed BAA does not enter Medcurity's signer workflow.
            Keep this subtree mounted: the legacy autosave serializes this form and
            edit.blade.php's submit guard still owns its validation. Bootstrap's
            display-only utility gives the upload path an immediate, reversible
            transition without losing inputs, bindings, or an existing draft.
        -->
        <div id="baa-upload-intermediate-fields" class="baa-upload-intermediate-fields" :class="{ 'd-none': alreadySigned }">
            <BaaMedcurityAssociates></BaaMedcurityAssociates>
        </div>

        <div class="row">
            <div class="form-group col-6">
                <label for="uploaded_baa">
                    Upload an existing BAA
                    <template v-if="alreadySigned">
                        <span class="text-danger" aria-hidden="true">*</span><span class="sr-only"> (required)</span>
                    </template>
                </label>
                <input class="form-file-input" type="file" name="uploaded_baa" id="uploaded_baa"
                       :required="alreadySigned" :aria-required="alreadySigned ? 'true' : 'false'">
            </div>
        </div>

        <div class="row" v-if="Object.keys(oldValues).length && oldValues.publicFilePath">
            <div class="col-12">
                <label>Currently Uploaded BAA Document: <strong>{{ oldValues.original_filename }}</strong></label>
                <iframe :src="`http://docs.google.com/viewer?url=${encodeURI(oldValues.publicFilePath)}&embedded=true`"
                        style="width:100%; height: 750px;border: none;"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'
    import BaaMedcurityAssociates from './BaaMedcurityAssociates'
    import Datepicker from 'vuejs-datepicker'
    import moment from 'moment'

    export default {
        name: "BaaUploadInputs",
        components: {
            BaaMedcurityAssociates,
            Datepicker
        },
        data: function(){
            return {
                baaTemplate: '',
                alreadySigned: false,
            }
        },
        computed: {
            ...mapState('baaForm',[
                'inputs',
                'medcurityBaas',
                'statuses',
                'selectedBaa',
                'oldValues',
                'renewFrequencies'
            ])
        },
        created(){
            // getOldValues() may serialise booleans as 0/1 strings. Do not use
            // JavaScript truthiness here: the string "0" would otherwise check the
            // box and hide the signer fields for an unsigned BAA.
            this.alreadySigned = this.isAlreadySigned(this.inputs.already_signed);
        },
        mounted(){
            this.populateBaaTemplate();
        },
        methods: {
            ...mapMutations('baaForm',[
                'selectMedcurityBaa',
                'setFieldsMatchedMedcurityBaa'
            ]),
            customFormatter(date) {
                return moment(date).format('YYYY-MM-DD');
            },
            isAlreadySigned(value) {
                return value === true || value === 1 || value === '1';
            },
            populateBaaTemplate(){
                if(!Object.keys(this.selectedBaa).length){
                    return
                }
                this.baaTemplate = this.selectedBaa.id
            },
            changeMaturityBaa(e){
                const elValue = e.target.value,
                    currentSelection = e.target.dataset.currentSelection

                if(this.inputs.title || this.inputs.baa){
                    if(!confirm('Choosing a new BAA template will overwrite your current title and BAA in view.\n\r Would you like to continue?')){
                        this.baaTemplate = currentSelection
                        return false
                    }
                }

                e.target.dataset.currentSelection = elValue
                this.selectMedcurityBaa(elValue)
                this.setFieldsMatchedMedcurityBaa()

            },
        }
    }
</script>

<style scoped>

</style>
